import { render } from "./post-confirm-buy-metfone-esim.vue?vue&type=template&id=827bed26"
import script from "./post-confirm-buy-metfone-esim.vue?vue&type=script&lang=js"
export * from "./post-confirm-buy-metfone-esim.vue?vue&type=script&lang=js"

import "./post-confirm-buy-metfone-esim.vue?vue&type=style&index=0&id=827bed26&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__